import { useMemo } from "react";
import { HelpContent } from "../../../../application/domain/help/help-entity";

type Heading = {
  level: number;
  text: string;
};

const extractHeadings = (html: string): Heading[] => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const headings: Heading[] = [];

  doc.querySelectorAll("h1, h2, h3, h4").forEach((heading) => {
    const level = parseInt(heading.tagName.substring(1), 10);
    const text = heading.textContent?.trim() || "";
    headings.push({ level, text });
  });

  return headings;
};

export const useContentsHeadingListController = (content: HelpContent) => {
  const headings = useMemo(() => {
    return extractHeadings(content.metadata.content);
  }, [content.metadata.content]);

  return { headings };
};
